// JS for inclusion page
$(document).ready(function() {
    $('.inclusions-nav a').click(function(e) {
        e.preventDefault();
        $(this)
            .addClass('active')
            .siblings()
            .removeClass('active');
        $(this.hash)
            .removeClass('hidden')
            .siblings('section')
            .addClass('hidden');
    });
    // doesnt work
    // if ($('.video-js').length) {
    //     var campaignVideo = videojs($('.video-js')[0]),
    //         $campaignButton = $('.designer-kitchen-campaign__feature__button');
    //     $('#video-modal')
    //         .on('shown.bs.modal', function(event) {
    //             $('#video-modal h3').fitText(1.215);
    //             const playPromise = campaignVideo.play();
    //             playPromise.catch(_ => {});
    //         })
    //         .on('hide.bs.modal', function(event) {
    //             campaignVideo.pause();
    //         });
    //
    //     campaignVideo.on('timeupdate', function() {
    //         if (campaignVideo.remainingTime() < 22.5 && campaignVideo.currentTime() > 0) {
    //             $campaignButton.addClass('active');
    //         } else {
    //             $campaignButton.removeClass('active');
    //         }
    //     });
    // }
});
